import { FC } from 'react';
import { FeaturedSupplierSpriteIcon } from './search-svg-sprite';

export const FeatureSupplierMarker: FC = () => (
  <div className="bsg">
    <div>
      <FeaturedSupplierSpriteIcon width={20} height={20} />
    </div>
  </div>
);
